// extracted by mini-css-extract-plugin
export var numpadContainer = "_n9-1";
export var phoneButton = "_n9-0";